import ApiService from './ApiService';

class FIXMessageLogService {
  async getFIXMessageLog(payload = {}) {
    try {
      const response = await ApiService.call('/secured/get_fix_message_log', 'POST', payload);
      let data = response;

      return {
        fixMessageLogList: data.result,
        totalCount: data.totalCount,
        page: data.offset,
        size: data.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getFIXExecutionOrderLog(payload = {}) {
    try {
      const response = await ApiService.call(
        '/secured/get_fix_execution_order_report',
        'POST',
        payload,
      );
      let data = response;

      return {
        executionOrderReportList: data.result,
        totalCount: data.totalCount,
        page: data.offset,
        size: data.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new FIXMessageLogService();
